import { ItemType } from "antd/es/menu/hooks/useItems";

export class ClickTrackerService {
  static FIXED_POSITION_ELEMENT_KEY = "editEntity";

  clicks = new Map<string, number>();

  click = (key: string) => {
    const clicks = new Map(this.clicks);
    clicks.set(key, (this.clicks.get(key) ?? 0) + 1);
    this.clicks = clicks;
  };

  comparator = (a: ItemType, b: ItemType) => {
    if (!a || !b) {
      return 0;
    }

    if (b.key === ClickTrackerService.FIXED_POSITION_ELEMENT_KEY) {
      // Edit action has fixed position and always stays first
      return 1;
    }
    if (a.key === ClickTrackerService.FIXED_POSITION_ELEMENT_KEY) {
      return -1;
    }

    const keyA = a.key ? String(a.key) : undefined;
    const keyB = b.key ? String(b.key) : undefined;

    if (keyA && keyB) {
      const clicksA = this.clicks.get(keyA) ?? 0;
      const clicksB = this.clicks.get(keyB) ?? 0;
      return clicksB - clicksA;
    }

    return 0;
  };
}

const clickTrackerService = new ClickTrackerService();

export default clickTrackerService;
